<template>
  <div class="header">
    <Container class="container-spacing-md container-none">
      <div class="header-content">
        <a href="https://www.union.sk">
          <IconLogo />
        </a>
        <div class="header-wrapper">
          <slot />
          <div class="header-wrapper">
            <div class="header-icon-container" @click="openMobileDialog">
              <IconPhone />
            </div>
            <p class="header-phone-text">
              0850 003 333
            </p>
          </div>
        </div>
      </div>
    </Container>
  </div>
</template>

<script>
import Container from '@/components/Container/Container.vue';
import IconLogo from '@/components/Icons/IconLogo.vue';
import IconPhone from '@/components/Icons/IconPhone.vue';
import { checkIfDeviceIsMobile } from '@/utils/deviceType.js';

export default {
  name: 'Header',
  components: {
    Container,
    IconLogo,
    IconPhone,
  },
  methods: {
    openMobileDialog() {
      const phoneNumber = '0850 003 333';

      if (checkIfDeviceIsMobile()) {
        this.redirectToPhoneNumber(phoneNumber);
      }
    },
    redirectToPhoneNumber(phoneNumber) {
      window.location.href = `tel:${phoneNumber}`;
    },
  },
};
</script>
